import React, { useEffect, useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import testImg from "../../../../Assets/img/test-img.png";
import Free from "../../../../Assets/img/Free.png";
import HTMLParser from "../../../Components/HTMLParser";
import Loader from "../../../Components/Loader/Loader";
import {
  claimFreeSet,
  errorMessage,
  getSchemeSets,
} from "../../../../Features/LKWBTestApi/LKWBTestApi";

// Buy step between choosing a set and taking its test. Free sets are claimed
// here; paid sets go to the existing UBT checkout (eSewa / Khalti / reward points).
const LKWBTestBuy = () => {
  const { id, setId } = useParams();
  const navigate = useNavigate();
  const token = useSelector((state) => state.auth.currentUser.token);
  const [set, setSet] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [claiming, setClaiming] = useState(false);

  const backLink = `/dashboard/lkwb-test/${id}`;
  const testLink = `/dashboard/lkwb-test/${id}/sets/${setId}`;

  useEffect(() => {
    let cancelled = false;
    setIsLoading(true);
    getSchemeSets(id, token)
      .then((data) => {
        if (cancelled) return;
        const found = (data?.sets || []).find(
          (s) => String(s.id) === String(setId)
        );
        if (!found) {
          setError("Set not found.");
        } else if (found.status) {
          // Already bought: nothing to buy, go straight to the test.
          navigate(testLink, { replace: true });
        } else {
          setSet(found);
          setError("");
        }
      })
      .catch((err) => {
        if (!cancelled) setError(errorMessage(err, "Unable to load this set."));
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [id, setId, token, navigate, testLink]);

  const isFree = set && (!set.price || set.canAccessSet);

  const claim = () => {
    setClaiming(true);
    claimFreeSet(setId, token)
      .then(() => {
        toast.success(`You have successfully claimed ${set.title}`);
        navigate(testLink, { replace: true });
      })
      .catch((err) => {
        toast.error(errorMessage(err, "Unable to claim this set."));
        setClaiming(false);
      });
  };

  if (isLoading) {
    return (
      <div className="loading__mode bigLoading">
        <Loader />
      </div>
    );
  }

  return (
    <>
      <Modal show={claiming} backdrop="static" centered>
        <Modal.Body>
          <div className="pleasewait">
            <Loader label="Claiming your set" />
            <p>Please wait.</p>
          </div>
        </Modal.Body>
      </Modal>
      <Row>
        <Col md={9}>
          <div className="dashboard-contents dashboard-buytest">
            <Link to={backLink} className="btn btn-small">
              Go Back
            </Link>
            {error || !set ? (
              <div className="youhavenot-container mt-3">
                <p>{error || "Set not found."}</p>
              </div>
            ) : (
              <>
                <div className="dashboard-contentshead">
                  <img src={testImg} alt="" />
                  <div className="packageName">
                    <h3 className="eachdashboard-title">Set Name</h3>
                    <p>{set.title}</p>
                  </div>
                </div>
                {set.description && (
                  <div className="eachdashboard-detail">
                    <h3 className="eachdashboard-title">Set Detail</h3>
                    <HTMLParser>{set.description}</HTMLParser>
                  </div>
                )}
                <div className="eachdashboard-detail">
                  <h3 className="eachdashboard-title">Set Price</h3>
                  {isFree ? (
                    <p>{set.canAccessSet ? "Free For Premium User" : "Free"}</p>
                  ) : (
                    <p>
                      Price: Rs. <strong>{set.price}</strong>
                      {set.discount > 0 && set.base_price ? (
                        <del className="ms-2">{set.base_price}</del>
                      ) : null}
                    </p>
                  )}
                </div>
              </>
            )}
          </div>

          {set && (
            <div className="dashboard-contents">
              <div className="choosedigital-payment">
                {isFree ? (
                  <>
                    <p>*This set is free. Claim it to start the test.</p>
                    <div className="choosepayment">
                      <Form>
                        <div className="mb-3 d-flex align-items-center paymentoptions">
                          <Form.Check
                            type="radio"
                            name="Free"
                            checked
                            readOnly
                            label={
                              <div className="labelImg">
                                <img src={Free} alt="" />
                                <p>Free</p>
                              </div>
                            }
                          />
                        </div>
                      </Form>
                    </div>
                  </>
                ) : (
                  <p>
                    *You can use eSewa, Khalti or Reward Points to buy this set
                    on the next page.
                  </p>
                )}
                <div className="btn-action-container">
                  <Link to={backLink} className="btn btn-secondary">
                    Cancel
                  </Link>
                  {isFree ? (
                    <button
                      className="btn btn-green"
                      onClick={claim}
                      disabled={claiming}
                    >
                      Claim Now
                    </button>
                  ) : (
                    <Link
                      to={`/dashboard/ubt-test/ubt-test-buy/${setId}`}
                      className="btn btn-green"
                    >
                      Buy Now
                    </Link>
                  )}
                </div>
              </div>
            </div>
          )}
        </Col>
        <Col md={3} className="rightsidebar"></Col>
      </Row>
    </>
  );
};

export default LKWBTestBuy;
